import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { CertificateButton } from "./CertificateButtonContainer.styles";
import { CertificateButtonPros } from "./CertificateButtonContainer.types";
import { Badge } from "../Badge";

export const CertificateButtonContainer = ({
  iconURL,
  small,
  downloadHandler,
  isDownloading,
  learningObjectTitle
}: CertificateButtonPros) => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <CertificateButton aria-label={ `${t("download_certificate")} ${learningObjectTitle}` } loading={ isDownloading } sx={ {
      "& .MuiLoadingButton-loadingIndicator": {
        color: theme.customColors.textPrimary
      }
    } } onClick={ ()=> !isDownloading && downloadHandler() }>
      <Badge
        loading={ isDownloading }
        iconURL={ iconURL }
        small={ small }
      />
    </CertificateButton>
  );
};
